(function() {
    'use strict';

    angular.module('machine')
        .controller('MachineActionCreateController', MachineActionCreateController);

    MachineActionCreateController.$inject = ['$uibModalInstance'];

    function MachineActionCreateController($uibModalInstance) {
        var self = this;

        self.actionData = {
            'name': '',
            'description': '',
            'checklist_before_start': [],
            'checklist_before_end': [],
            'is_work_preview': false,
            'is_mounting_info': false,
            'is_use_codes_verification': false,
            'is_use_codes_verification_print': false,
            'is_assembly_codes_verification': false,
        };
        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close(self.actionData);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
